const config = require("./config.common");

module.exports = config;
